import React from 'react';
import { Create } from 'react-admin';
import PromoForm from './PromoForm';

export default ({ ...props }) => {
  
  return <Create {...props} title="Aggiungi promo">
    <PromoForm redirect="edit" />
  </Create>
}